import UserApiService from 'src/services/user/userApiService';
import AuthApiService from 'src/services/user/authApiService';
import AppsApiService from 'src/services/user/appsApiService';
import SupplierApiService from 'src/services/supplier/supplierApiService';
import MagicLinkApiService from 'src/services/supplier/magicLinkApiService';
import PurchaseOrderApiService from 'src/services/supplier/purchaseOrderDataApiService';

import genericApiService from 'src/services/generic/genericApiService';

import DocumentTypeApiService from 'src/services/document/TypesApiService';
import DocumentLockApiService from 'src/services/document/LockApiService';
import ExportApiService from 'src/services/document/exportApiService';
import DocumentDetailApiService from 'src/services/document/DetailApiService';
import DocumentPOApiService from 'src/services/document/POApiService';
import FullSearchApiService from 'src/services/document/FullSearchApiService';
import PermissionsApiService from 'src/services/document/PermissionsApiService';
import OrgPreferenceApiService from 'src/services/document/OrgPreferenceApiService';
import DocumentListApiService from 'src/services/document/ListApiService';
import DocumentSubTypesApiService from 'src/services/document/SubTypesApiService';
import DocScriptApiService from 'src/services/document/ScriptApiService';
import AutoAccountingApiService from 'src/services/document/AutoAccountingApiService';
import RegexesApiService from 'src/services/document/RegexesApiService';
import AITableApiService from 'src/services/document/AITableApiService';
import DocumentSupplierApiService from 'src/services/document/SupplierApiService';
import TaskApiService from 'src/services/document/TaskApiService';
import AsnApiService from 'src/services/document/AsnApiService';
import NotificationsApiService from 'src/services/document/NotificationsApiService';
import PurchaseOrderService from 'src/services/document/PurchaseOrderService';
import InvoiceDashboardService from 'src/services/document/InvoiceService';
import DashboardListViewService from './dashboard/DashboardListViewService';

import ReportApiService from 'src/services/document/ReportApiService';

import DocumentFlowDataService from './document/FlowDataService';

import HealthCheckApiService from 'src/services/app/healthCheckApiService';

import ConvertAmountService from 'src/services/locale/convertAmountService';
import FormatDateService from 'src/services/locale/formatDateService';

import FormBuilderApiService from 'src/services/formBuilder/formBuilderApiService';

import SupportApiService from 'src/services/support/supportApiService';

import MasterDataApiService from 'src/services/settings/MasterDataApiService';
import SubOrgsApiService from 'src/services/settings/subOrgsApiService';
import DocStatusNotificationsApiService from 'src/services/settings/DocStatusNotificationsApiService';
import ClassificationRulesApiService from 'src/services/settings/ClassificationRulesApiService';
import ValidationRulesApiService from 'src/services/settings/ValidationRulesApiService';
import NotificationRoutingApiService from 'src/services/settings/NotificationRoutingApiService';
import PolicyWizardApiService from 'src/services/settings/PolicyWizardApiService';
import AIModelsAndLabelsApiService from 'src/services/settings/AIModelsAndLabelsApiService';
import DocFieldsApiService from 'src/services/settings/DocFieldsApiService';
import SamlConfigApiService from 'src/services/settings/SamlConfigApiService';
import ImportApiService from 'src/services/settings/ImportApiService';
import ListOfValuesApiService from 'src/services/settings/ListOfValuesApiService';
import WorkflowApiService from 'src/services/workflow/WorkflowApiService';
import WorkflowTestApiService from 'src/services/workflow/WorkflowTestApiService';
import DocTypeApiService from 'src/services/settings/DocTypeApiService';
import SupplierGroupApiService from 'src/services/settings/SupplierGroupApiService';
import AgentApiService from 'src/services/settings/AgentApiService';
import DiscordApiService from 'src/services/settings/DiscordApiService';
import SlackApiService from 'src/services/settings/SlackApiService';
import TeamsApiService from 'src/services/settings/TeamsApiService';
import SupplierOrganisationApiService from 'src/services/settings/SupplierOrganisationApiService';
import UserAndSupplierGroupMapping from 'src/services/settings/UserSupplierGroupMappingApiService';
import EmailTemplateApiService from 'src/services/settings/EmailTemplateApiService';
import EmailDocumentApiService from 'src/services/email/EmailDocumentApiService';
import WatchdogApiService from 'src/services/settings/WatchdogApiService';
import VertexApiService from 'src/services/settings/VertexApiService';
import SupplierRegistrationReferenceDocumentsApiService from 'src/services/settings/SupplierRegistrationReferenceDocumentsApiService';

import OrgApiService from 'src/services/organization/OrgApiService';
import DocXsltApiService from 'src/services/document/EDoctypeApiService';
import ShipmentApiService from 'src/services/document/ShipmentApiService';
import TermAndConditionApiService from './settings/TermAndConditionApiService';
import DecisionApiService from './document/DecisionApiService';
import SupplierDataApiService from 'src/supplier/service/supplierDataApiService';
import SupplierExportCongApiService from './supplierExportConfigService';
import OperatorApiService from 'src/services/operator/OperatorApiService';
import DocNetApiService from './docnet/DocNetApiService';
import { XsltApiService } from './xslt/xsltApiService';
import SupplierAIModelService from 'src/services/document/SupplierAIModelService';

import IdeasApiService from 'src/services/ideas/IdeasApiService';
import GraphExplorerApiService from 'src/services/document/GraphExplorerApiService';
import DocNetIssueService from 'src/services/docnet/DocNetIssueService';
import DocNetMissionService from 'src/services/docnet/DocNetMissionService';
import DocNetInboxService from 'src/services/docnet/DocNetInboxService';
import DocNetAgentProfileService from 'src/services/docnet/DocNetAgentProfileService';
import DocNetProcessService from 'src/services/docnet/DocNetProcessService';

import ActivityLogsApiService from 'src/services/activityLogs/ActivityLogsApiService';
import PerformanceLogsApiService from 'src/services/performanceLogs/PerformanceLogsApiService';
import SystemLogsApiService from 'src/services/systemLogs/SystemLogsApiService';
import SupplierStatisticApiService from 'src/services/ai/SupplierStatisticApiService';
import LoginAnalyticsService from 'src/services/loginAnalytics/LoginAnalyticsService';
import SupplierCalculationsApiService from './document/SupplierCalculationsApiService';
import InvoiceCalculationApiService from './settings/InvoiceCalculationApiService';

// import WebSocketService from 'src/services/app/WebSocketService.js';
export const operatorApiService: OperatorApiService = new OperatorApiService();
export const docNetApiService: DocNetApiService = new DocNetApiService();
export const userApiService: UserApiService = new UserApiService();
export const authApiService: AuthApiService = new AuthApiService();
export const appsApiService: AppsApiService = new AppsApiService();
export const supplierApiService: SupplierApiService = new SupplierApiService();
export const supplierDataApiService = new SupplierDataApiService();
export const magicLinkApiService: MagicLinkApiService =
  new MagicLinkApiService();
export const purchaseOrderApiService: PurchaseOrderApiService =
  new PurchaseOrderApiService();
export const supplierExportCongApiService: SupplierExportCongApiService =
  new SupplierExportCongApiService();
export const masterDataApiService: MasterDataApiService =
  new MasterDataApiService();

export const genericService: genericApiService = new genericApiService();

export const documentTypeApiService: DocumentTypeApiService =
  new DocumentTypeApiService();
export const documentLockApiService: DocumentLockApiService =
  new DocumentLockApiService();
export const exportApiService: ExportApiService = new ExportApiService();
export const documentDetailApiService: DocumentDetailApiService =
  new DocumentDetailApiService({});
export const documentPOApiService: DocumentPOApiService =
  new DocumentPOApiService();
export const fullSearchApiService: FullSearchApiService =
  new FullSearchApiService();
export const documentPermissionsApiService: PermissionsApiService =
  new PermissionsApiService();
export const orgPreferenceApiService: OrgPreferenceApiService =
  new OrgPreferenceApiService();
export const documentListApiService: DocumentListApiService =
  new DocumentListApiService();
export const documentSubTypesApiService: DocumentSubTypesApiService =
  new DocumentSubTypesApiService();
export const docScriptApiService: DocScriptApiService =
  new DocScriptApiService();
export const docXsltApiService: DocXsltApiService = new DocXsltApiService();
export const autoAccountingApiService: AutoAccountingApiService =
  new AutoAccountingApiService();
export const documentRegexesApiService: RegexesApiService =
  new RegexesApiService();
export const reportApiService: ReportApiService = new ReportApiService();
export const aiTableApiService: AITableApiService = new AITableApiService();
export const documentSupplierApiService: DocumentSupplierApiService =
  new DocumentSupplierApiService({});
export const taskApiService: TaskApiService = new TaskApiService({});
export const asnApiService: AsnApiService = new AsnApiService({});

export const notificationsApiService: NotificationsApiService =
  new NotificationsApiService({});
export const purchaseOrderService: PurchaseOrderService =
  new PurchaseOrderService({});
export const invoiceDashboardService: InvoiceDashboardService =
  new InvoiceDashboardService({});
export const dashboardListViewService: DashboardListViewService =
  new DashboardListViewService({});

export const documentFlowDataService: DocumentFlowDataService =
  new DocumentFlowDataService();

export const healthCheckApiService: HealthCheckApiService =
  new HealthCheckApiService();

export const supportApiService: SupportApiService = new SupportApiService();

export const subOrgsApiService: SubOrgsApiService = new SubOrgsApiService();
export const docStatusNotificationsApiService: DocStatusNotificationsApiService =
  new DocStatusNotificationsApiService();
export const classificationRulesApiService: ClassificationRulesApiService =
  new ClassificationRulesApiService();
export const validationRulesApiService: ValidationRulesApiService =
  new ValidationRulesApiService();
export const notificationRoutingApiService: NotificationRoutingApiService =
  new NotificationRoutingApiService();
export const policyWizardApiService: PolicyWizardApiService =
  new PolicyWizardApiService();
export const aiModelsAndLabelsApiService: AIModelsAndLabelsApiService =
  new AIModelsAndLabelsApiService();
export const docFieldsApiService: DocFieldsApiService =
  new DocFieldsApiService();
export const samlConfigApiService: SamlConfigApiService =
  new SamlConfigApiService();
export const importApiService: ImportApiService = new ImportApiService();
export const listOfValuesApiService: ListOfValuesApiService =
  new ListOfValuesApiService();
export const docTypeApiService: DocTypeApiService = new DocTypeApiService();
export const supplierGroupApiService: SupplierGroupApiService =
  new SupplierGroupApiService();
export const agentApiService: AgentApiService = new AgentApiService();
export const discordApiService: DiscordApiService = new DiscordApiService();
export const slackApiService: SlackApiService = new SlackApiService();
export const teamsApiService: TeamsApiService = new TeamsApiService();
export const supplierOrganisationApiService: SupplierOrganisationApiService =
  new SupplierOrganisationApiService();
export const userAndSupplierGroupMapping: UserAndSupplierGroupMapping =
  new UserAndSupplierGroupMapping();
export const emailTemplateService: EmailTemplateApiService =
  new EmailTemplateApiService({});
export const emailDocumentApiService: EmailDocumentApiService =
  new EmailDocumentApiService({});
export const supplierRegistrationReferenceDocumentsApiService: SupplierRegistrationReferenceDocumentsApiService =
  new SupplierRegistrationReferenceDocumentsApiService({});

export const convertAmountService: ConvertAmountService =
  new ConvertAmountService();
export const formatDateService: FormatDateService = new FormatDateService();

export const formBuilderApiService: FormBuilderApiService =
  new FormBuilderApiService();

export const workflowApiService: WorkflowApiService = new WorkflowApiService();

export const workflowTestApiService: WorkflowTestApiService =
  new WorkflowTestApiService();

export const decisionApiService: DecisionApiService = new DecisionApiService();

export const orgApiService: OrgApiService = new OrgApiService();
export const shipmentApiService: ShipmentApiService = new ShipmentApiService();
export const termAndConditionApiService: TermAndConditionApiService =
  new TermAndConditionApiService();
export const xsltApiService: XsltApiService = new XsltApiService();
// export const webSocketService: WebSocketService = new WebSocketService();

export const supplierAIModelService: SupplierAIModelService =
  new SupplierAIModelService({});

export const activityLogsApiService: ActivityLogsApiService =
  new ActivityLogsApiService();
export const performanceLogsApiService: PerformanceLogsApiService =
  new PerformanceLogsApiService();
export const systemLogsApiService: SystemLogsApiService =
  new SystemLogsApiService();
export const supplierStatisticApiService: SupplierStatisticApiService =
  new SupplierStatisticApiService();
export const loginAnalyticsService: LoginAnalyticsService =
  new LoginAnalyticsService();
export const supplierCalculationsApiService: SupplierCalculationsApiService =
  new SupplierCalculationsApiService();
export const invoiceCalculationApiService: InvoiceCalculationApiService =
  new InvoiceCalculationApiService();
export const watchdogApiService: WatchdogApiService = new WatchdogApiService();
export const vertexApiService: VertexApiService = new VertexApiService();
export const ideasApiService: IdeasApiService = new IdeasApiService();
export const docNetIssueService: DocNetIssueService = new DocNetIssueService();
export const docNetMissionService: DocNetMissionService =
  new DocNetMissionService();
export const docNetInboxService: DocNetInboxService = new DocNetInboxService();
export const docNetAgentProfileService: DocNetAgentProfileService =
  new DocNetAgentProfileService();
export const docNetProcessService: DocNetProcessService =
  new DocNetProcessService();
export const graphExplorerApiService: GraphExplorerApiService =
  new GraphExplorerApiService();
